import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { GuestDialogComponent } from './guest-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class GuestDialogService {
  constructor(private dialog: DialogService) {}

  open(guestId?: string) {
    const defaultConfig: MatDialogConfig = {
      width: '750px',
      height: 'auto',
      data: { guestId },
    }

    return this.dialog.openVariableDialog(GuestDialogComponent, defaultConfig)
  }
}
